import React from 'react';
import ReactMde from 'react-mde';
import { InputLabelEditor } from '../../../../../components/InputLabelEditor';
import { Separator } from '../../../../../components/NotificationEditor/components/Separator';
import ChallengeImagePicker from './ChallengeImagePicker';
import { CreateChallengeStyles } from '../styles';
import { converter } from '../utils';
import { ChallengeLocalization } from '../types';

type ChallengeInternationalSectionProps = {
  selectedLanguage: string;
  dataByLanguage: ChallengeLocalization | undefined;
  onChange:  (key: string, value: string | number | undefined) => void;
  selectedTab: any;
  setSelectedTab: any;
  onPostUpload: (acceptedFiles: any, onSuccess: (imageUrl: string) => void) => void;
  editedChallengeId?: boolean
};

const ChallengeInternationalSection = ({
  selectedLanguage,
  dataByLanguage,
  onChange,
  selectedTab,
  setSelectedTab,
  onPostUpload,
}: ChallengeInternationalSectionProps) => {

  return (
    <div style={CreateChallengeStyles.section}>
      <div style={CreateChallengeStyles.inputContainer}>
        {/* 
          // In the future, we'll add ability to translate edited text in here. 
         <LanguageSelector
          onChange={language => setSelectedLanguage(language)}
          selectedLanguage={selectedLanguage}
         /> */}
        <div style={CreateChallengeStyles.inputContainer}>
          <InputLabelEditor
            title="Comment s'intitule ce challenge ?"
            isRequired
            flag={selectedLanguage}
          />
          <textarea
            className="form-control"
            value={dataByLanguage?.name || ''}
            onChange={e =>
              onChange(`localization.${selectedLanguage}.name`, e.target.value)
            }
          />
        </div>
        <Separator />
        <div style={CreateChallengeStyles.inputContainer}>
          <InputLabelEditor
            title="Ecris une description à propos du challenge."
            flag={selectedLanguage}
          />
          <ReactMde
            toolbarCommands={[
              ['bold', 'italic', 'strikethrough'],
              ['unordered-list', 'ordered-list'],
              ['link'],
            ]}
            value={dataByLanguage?.description || ''}
            onChange={value =>
              onChange(`localization.${selectedLanguage}.description`, value)
            }
            selectedTab={selectedTab}
            onTabChange={setSelectedTab}
            generateMarkdownPreview={markdown =>
              Promise.resolve(converter.makeHtml(markdown))
            }
          />
        </div>
        <Separator />
      </div>

      <div style={CreateChallengeStyles.inputContainer}>
        <InputLabelEditor
          title="Ecris une dotation pour le challenge"
          flag={selectedLanguage}
        />
          <ReactMde
            toolbarCommands={[
              ['bold', 'italic', 'strikethrough'],
              ['unordered-list', 'ordered-list'],
              ['link'],
            ]}
            value={dataByLanguage?.supervisedDescription || ''}
            onChange={value =>
              onChange(`localization.${selectedLanguage}.supervisedDescription`, value)
            }
            selectedTab={selectedTab}
            onTabChange={setSelectedTab}
            generateMarkdownPreview={markdown =>
              Promise.resolve(converter.makeHtml(markdown))
            }
          />
      </div>

      <Separator />

      <ChallengeImagePicker
        selectedLanguage={selectedLanguage}
        dataByLanguage={dataByLanguage}
        field="imageUrl"
        isRequired
        onChange={onChange}
        title="Choisis l'image principale du challenge."
        onPostUpload={onPostUpload}
      />

      <Separator />

      <ChallengeImagePicker
        selectedLanguage={selectedLanguage}
        dataByLanguage={dataByLanguage}
        field="backgroundImageUrl"
        onChange={onChange}
        onPostUpload={onPostUpload}
        title="Choisis une image de fond du challenge."
      />

      <Separator />

      <ChallengeImagePicker
        selectedLanguage={selectedLanguage}
        dataByLanguage={dataByLanguage}
        field="presentationImageUrl"
        onChange={onChange}
        onPostUpload={onPostUpload}
        title="Choisis une image pour la présentation du challenge."
      />

      <Separator />

    </div>
  );
};

export default ChallengeInternationalSection;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/MPPCreateChallengeEditor/components/ChallengeInternationalSection.tsx